module.exports = __webpack_public_path__ + "img/Icon-Keyboard-Arrow-Left-white.1fc05978.svg";